module.exports = __webpack_public_path__ + "img/advisor.575c6aa3.jpg";